import React from "react";
import { Shimmer } from "components/shimmer";
import classNames from "classnames";
import { useSelfEditPermission } from "permissions/hooks/useSelfEditPermission";

/**
 * Permission-controlled input specifically for user profile fields
 * Supports both admin editing and self-editing of specific fields
 */
export const UserFieldInput = ({
  targetItem,
  field,
  className,
  children,
  type,
  showWhenDisabled = true,
  isDisabled = false,
  disabledMessage,
  fallback = null,
  showDisabled = false,
  collection
}) => {
  const { data: selfEditPermission, isLoading } = useSelfEditPermission(
    targetItem,
    field,
    collection
  );

  if (isLoading) {
    return <Shimmer className="h-10" />;
  }

  const canEdit = selfEditPermission?.canEdit || false;
  const disabled = !canEdit || showDisabled || isDisabled;

  if (!showWhenDisabled && disabled) {
    return disabledMessage ? (
      <div className="text-sm text-gray-500 italic">{disabledMessage}</div>
    ) : fallback ? (
      fallback
    ) : null;
  }

  return (
    <div
      className={classNames(
        "w-full",
        {
          "opacity-60 cursor-not-allowed": disabled,
        },
        { "grid gap-2": type === "form" },
        className,
      )}
    >
      {React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child, {
            disabled: disabled || child.props.disabled,
            "aria-disabled": disabled,
          });
        }
        return child;
      })}
    </div>
  );
};
